/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const ThumbsUp = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 17 19">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25723 0C8.68565 0 8.15328 0.290645 7.84419 0.771451L3.86012 6.9689C3.49413 6.37102 2.83495 5.97208 2.0826 5.97208C0.932413 5.97208 0 6.90449 0 8.05468V15.9441C0 17.0943 0.932413 18.0267 2.0826 18.0267C2.80041 18.0267 3.43339 17.6636 3.80786 17.111C4.26608 17.6335 4.93863 17.9634 5.68823 17.9634H10.6603C11.6072 17.9634 12.4729 17.4284 12.8963 16.5815L16.3684 9.63732C17.1996 7.97507 15.9908 6.01928 14.1324 6.01928H9.81493L10.8779 2.12183C11.1693 1.05322 10.3649 0 9.25723 0ZM8.68537 1.31221C8.81046 1.11762 9.02591 1 9.25723 1C9.7055 1 10.0311 1.42624 9.91311 1.85871L8.67793 6.38773L8.50568 7.01928H9.16031H14.1324C15.2474 7.01928 15.9727 8.19275 15.474 9.19011L12.0019 16.1343C11.7478 16.6424 11.2284 16.9634 10.6603 16.9634H5.68823C4.85981 16.9634 4.18823 16.2919 4.18823 15.4634V8.30776L8.68537 1.31221ZM3.16521 8.05468V15.9441C3.16521 16.542 2.68051 17.0267 2.0826 17.0267C1.4847 17.0267 1 16.542 1 15.9441V8.05468C1 7.45678 1.4847 6.97208 2.0826 6.97208C2.68051 6.97208 3.16521 7.45677 3.16521 8.05468Z"
        fill="#3C3C3C"
      />
    </BaseSvgIcon>
  )
}

export default ThumbsUp
